export const typographyTheme = {
  fontSize: 14,
  fontSizeHeading1: 36,
  fontSizeHeading3: 30,
  lineHeightHeading1: 44.64,
  lineHeightHeading3: 39.69,
};
